<div class="mx-auto my-10 w-full">
  <span class="text-5xl font-extrabold text-ica-primary">Bienvenido - Administrador</span>
</div>
